"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section id="hero" className="relative w-full min-h-[600px] lg:min-h-[800px] flex flex-col overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-accent/20 blur-[120px]" />
        <div className="absolute inset-0 pointer-events-none">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1565554/img/hero_background_texture.png" alt="" className="w-full h-full object-cover opacity-[0.03] mix-blend-overlay" />
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10 flex-1 flex items-center py-12 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center w-full">
          
          {}
          <div className="lg:col-span-7 flex flex-col items-center lg:items-start text-center lg:text-left justify-center space-y-8 animate-in fade-in slide-in-from-bottom-8 duration-1000 fill-mode-both">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.1]">
                <span className="block text-foreground">Financial Intelligence</span>
                <span className="bg-gradient-to-r from-primary via-blue-600 to-accent bg-clip-text text-transparent">
                  for Service Professionals
                </span>
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                Profissa Pro™ helps entrepreneurs and project‑based businesses understand real profitability, control project finances, and make smarter financial decisions.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
              <Button asChild size="lg" className="h-14 px-8 text-base shadow-lg shadow-primary/20 transition-transform hover:scale-105">
                <Link to="/contact">
                  Explore the Platform
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base border-border hover:bg-secondary/50 group">
                <Link to="/services">
                  Our Methodology
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base border-border hover:bg-secondary/50">
                <Link to="/demo">
                  Watch Demo
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base border-border hover:bg-secondary/50">
                <Link to="/explore">
                  Profissa Pro
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-8 border-t border-border/50 flex justify-center lg:justify-start gap-8 md:gap-12 w-full lg:w-auto">
              <div className="transition-all duration-300 hover:scale-105 hover:opacity-80 cursor-default">
                <p className="text-3xl font-bold text-foreground">98%</p>
                <p className="text-sm text-muted-foreground">Customer Satisfaction</p>
              </div>
              <div className="transition-all duration-300 hover:scale-105 hover:opacity-80 cursor-default">
                <p className="text-3xl font-bold text-foreground">10+</p>
                <p className="text-sm text-muted-foreground">Years of Experience</p>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col items-center justify-center space-y-10 lg:space-y-14 animate-in fade-in slide-in-from-right-8 duration-1000 fill-mode-both">
            <img src="https://certain-zebra.10web.cloud/wp-content/uploads/2026/03/SaaS-dashboard-example-scaled.png" alt="Financial Intelligence Dashboard" className="rounded-xl shadow-2xl border border-border/50 max-w-md object-cover !w-[800px] !h-[440px] lg:max-w-none" />
            <div className="w-full text-center">
              <blockquote className="relative">
                {}
              </blockquote>
            </div>
          </div>

        </div>
      </div>
    </section>;
}